<template>
  <div class="bb-employment-termination-modal">
    <div class="bb-employment-termination-modal__title">
      Employment termination
    </div>
    <div class="bb-employment-termination-modal__body">
      <div class="bb-employment-termination-modal-item">
        <div class="bb-employment-termination-modal-item__label">
          Name
        </div>
        <div class="bb-employment-termination-modal-item__input">
          {{item.username}}
        </div>
      </div>
      <div class="bb-employment-termination-modal-item">
        <div class="bb-employment-termination-modal-item__label">
          Date
        </div>
        <div>
          <DataPicker
            @setDate="setDate"
            :type2="true"
            :noBorder="true"
          />
        </div>
        <div class="bb-employment-termination-modal-item-support">
          <i class="icon-info bb-employment-termination-modal-item-support__icon"/>
          <div class="bb-employment-termination-modal-item-support__text">
            Please indicate the last working day
          </div>
        </div>
      </div>
      <div class="bb-employment-termination-modal-item">
        <div class="bb-employment-termination-modal-item__label">
          Reason
        </div>
          <Radio
            name="radioOption"
            radio-text="Terminated"
            :isBigRadioText="true"
            :isSmall="true"
            value="2"
            :checked="isCheck"
            @radioChange="radioChange"
          />
          <Radio
            name="radioOption"
            radio-text="Resigned"
            value="3"
            :isBigRadioText="true"
            :isSmall="true"
            :checked="!isCheck"
            @radioChange="radioChange"
          />
      </div>
    </div>
  </div>
</template>

<script>
import Radio from '@/components/Main/Inputs/radio'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import moment from 'moment'

export default {
  name: 'EmploymentTerminationModal',
  components: {
    Radio,
    DataPicker
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isCheck: true
  }),
  methods: {
    radioChange (data) {
      const newItem = {
        ...this.item,
        deleteStatus: data
      }
      this.$emit('update:item', newItem)
    },
    setDate (data) {
      const newItem = {
        ...this.item,
        deleteDate: moment(data).format('YYYY-MM-DD')
      }
      this.$emit('update:item', newItem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bb-employment-termination-modal {
    width: 502px;
    position: relative;

     &__title {
       text-align: center;
       font-size: 17px;
       line-height: 20px;
       font-weight: 500;
     }
  }

  .bb-employment-termination-modal__body {
    margin: 19px 0 33px 0;
    display: grid;
    grid-gap: 20px 0;
  }

  .bb-employment-termination-modal-item {

    &__label {
      margin: 0 0 8px 0;
      font-size: 13px;
      line-height: 16px;
      font-weight: 600;
      color: $color-denim;
    }

    &__input {
      padding: 6px 10px 6px 10px;
      font-size: 14px;
      color: $color-gray;
      text-transform: capitalize;
      border-radius: 5px;
      border: 1px solid $color-mercury;
    }

  }

  .bb-employment-termination-modal-item-support {
    display: flex;
    align-items: center;
    margin: 8px 0 0 0;

    &__icon {
      margin: -4px 1px 0 -2px;
      font-size: 13px;
      color: $color-gray;
    }

    &__text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
      color: $color-gray;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/SettingsUsers/EmploymentTerminationModal/EmploymentTerminationModal.vue